const WhyHackiware = () => {
  return (
    <section className="bg-[#050505] py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Why Hackiware Exists</h2>
          <p className="text-white/70 leading-relaxed">
            Founded to bridge the gap between academic learning and industry requirements, Hackiware delivers
            high-impact workshops, seminars, and hands-on training designed by experienced practitioners.
            We believe cybersecurity is a shared responsibility—our mission is to prepare students and
            institutions with practical skills, real-world exposure, and ethical guidance to secure the digital future.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyHackiware;
